var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronLeftLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.43934 8.91131C3.85355 9.4971 3.85355 10.4468 4.43934 11.0326C4.54329 11.1366 4.6587 11.2221 4.7815 11.2891L11.053 17.5607C11.6388 18.1464 12.5886 18.1464 13.1743 17.5607C13.7601 16.9749 13.7601 16.0251 13.1743 15.4393L7.66415 9.92915L12.9246 4.66867C13.5104 4.08289 13.5104 3.13314 12.9246 2.54735C12.3388 1.96157 11.3891 1.96157 10.8033 2.54735L4.43934 8.91131Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeftLight);
export default __webpack_public_path__ + "static/media/chevron-left-light.7fa358189b0f70f68d341a11563fda68.svg";
export { ForwardRef as ReactComponent };